module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921081149_T.0313412a.jpg";